(function () {
    'use strict';

    angular.module('settings')
        .controller('SettingUpdateController', SettingUpdateController);

    SettingUpdateController.$inject = ['$state', 'settingDataSrvc', 'notificationSrvc', 'settingMessagesConst', 'errorNotificationSrvc'];

    function SettingUpdateController($state, settingDataSrvc, notificationSrvc, settingMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            value: [],
            description: [],
            nonFieldErrors: []
        };
        self.settingData = {};

        self.updateSetting = updateSetting;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getSetting();
        }

        function getSetting() {
            return settingDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function (response) {
                self.settingData = response;

                delete self.settingData.date_modified;
                delete self.settingData.date_added;
                return response;
            });
        }

        function updateSetting() {
            settingDataSrvc.update({
                pk: self.settingData.pk
            }, self.settingData).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", settingMessagesConst.update);
                    $state.go('layout.setting.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
